module.exports = "/_next/static/images/4-079f00307033de834973cc1c2778cee8.png";